import {Scripts} from './external-scripts'

const FRESHCHAT_HOST = 'https://pleohelp.freshchat.com'

const pathsToHideFreshchatWidget = [
    '/explore-product',
    '/explore-product-2',
    '/expense-report-roi-calculator',
    '/for-construction-companies',
]

const shouldHideFreshchatWidget = () => {
    return pathsToHideFreshchatWidget.some((path: string) =>
        new RegExp(path).test(window.location.pathname),
    )
}

const load = () => {
    if (!window.fcWidget) {
        const script = document.createElement('script')
        script.src = Scripts.FRESHCHAT_WIDGET
        script.async = true
        script.setAttribute('chat', 'true')
        script.setAttribute('widgetId', process.env.GATSBY_FRESHCHAT_WIDGET_ID ?? '')
        script.onload = initialise
        document.body.appendChild(script)
    }
}

const onLoaded = (handler: () => void) => window.fcWidget?.on('widget:loaded', handler)

const isInitialized = () => window.fcWidget?.isInitialized()

const isLoaded = () => window.fcWidget?.isLoaded()

const isOpen = () => window.fcWidget?.isOpen()

const initialise = async () => {
    window.fcSettings = {
        token: process.env.GATSBY_FRESHCHAT_TOKEN,
        host: FRESHCHAT_HOST,
    }

    // Ensure the widget is hidden on init in the listed pages
    const hideChatButton = shouldHideFreshchatWidget()
    window.fcWidgetMessengerConfig = {
        config: {
            headerProperty: {
                hideChatButton,
            },
        },
    }
}

const open = () => window.fcWidget?.open()

const destroy = () => window.fcWidget?.destroy()

const updateVisibility = () => {
    const hideChatButton = shouldHideFreshchatWidget()
    window.fcWidget?.setConfig({
        headerProperty: {
            hideChatButton,
        },
    })
}

export const Freshchat = {
    load,
    isLoaded,
    isOpen,
    initialise,
    open,
    destroy,
    onLoaded,
    isInitialized,
    updateVisibility,
}
